import React, { useState } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../redux/store/appStore';
import { STATUS } from '../../utils/status';
import { CircularProgress, TableHead, ToggleButton, ToggleButtonGroup, Typography } from '@mui/material';
import { useStyles } from '../../assets/styles/listTableStyle';
import TableRowItem from './dataInformationTableRowUnallocation';
import Error from '../error/error';
import { TableCellBody, TableCellHead } from '../table/tableCell';
import { useParams } from 'react-router-dom';
import { createDataAnalyseUnallocation } from '../../redux/slices/bulkAllocation';
import { SelectedId } from '../../redux/reducers/taskIdSlice';
interface DataInformationUnallocationTableProps {
    allocationType: string;
    taskerType: string;
    selectedType: string;
    selectedBox: string;
    selectedStage: string;
}

const DataInformationUnallocationTable: React.FC<DataInformationUnallocationTableProps> = ({ allocationType, taskerType, selectedStage, selectedType, selectedBox }) => {
    const classes = useStyles();
    const [tableSwitch, setTableSwitch] = useState("CURRENT");
    const dispatch = useDispatch<AppDispatch>();
    const { id } = useParams();
    const fileType3 = useSelector((state: RootState) => state.fileAllocation.file)
    const selectedEmails = useSelector((state: RootState) => state.selectedEmails.selectedEmail);
    const selectedEmailsReview = useSelector((state: RootState) => state.selectedEmailsReview.selectedEmailReview);
    const selectedIds = useSelector((state: RootState) => state.tasks.selectedIds);
    const analyseData = useSelector((state: RootState) => state.bulkAllocation.dataUnallocation.data)

    const createAnalyseStatus = useSelector((state: RootState) => state.bulkAllocation.createDataAnalyseUnallocationStatus);
    const headers = ["STAGE NAME", "UNALLOCATED COUNT"]

    const handleChangeToggle = (event: any, table: string) => {
        if (table !== null) {
            setTableSwitch(table);

            if (selectedType === 'Type 1') {
                const payload = {
                    project_id: id,
                    data: {
                        tasks: selectedIds.map((selectedId: SelectedId) => selectedId.id),
                        experts: taskerType === 'TASK' ? selectedEmails : selectedEmailsReview,
                    },
                    action_type: allocationType,
                    analyse_all: table === 'ALL',
                    stage: selectedStage,
                    action: allocationType === 'allocation' ? 'task_expert_mapping' : 'task_expert_unmapping',
                }
                dispatch(createDataAnalyseUnallocation({ payload }))
            }
            if (selectedType === 'Type 3') {
                const formData = new FormData()
                formData.append("project_id", id || '')
                formData.append("action", allocationType === 'allocation' ? 'task_assignment' : 'task_unassignment')
                formData.append("action_type", allocationType || '')
                formData.append("stage", selectedStage)
                if (table === 'ALL') {
                    formData.append("analyse_all", 'true');
                }
                if (fileType3) {
                    formData.append("data", fileType3);
                }
                dispatch(createDataAnalyseUnallocation({ payload: formData }))
            }
        }


    };

    return (
        <>
            <ToggleButtonGroup
                color="standard"
                value={tableSwitch}
                exclusive
                onChange={handleChangeToggle}
            >
                <ToggleButton
                    value="CURRENT"
                    style={{
                        border: 'none',
                        fontFamily: 'Montserrat',
                        fontSize: '14px',
                        fontWeight: 600,
                        lineHeight: '24px',
                        color: tableSwitch === 'CURRENT' ? '#03BBD2' : '#6C6C6C',
                        borderBottom: tableSwitch === 'CURRENT' ? '3px solid #03BBD2' : 'none',
                        backgroundColor: 'inherit',
                        textTransform: 'none'
                    }}
                >
                    Impacted Stage Summary
                </ToggleButton>
            </ToggleButtonGroup>
            <TableContainer sx={{ backgroundColor: 'white', minHeight: '200px' }}>
                {createAnalyseStatus === STATUS.PENDING && (
                    <div className={classes.progressDiv}>
                        <CircularProgress />
                    </div>
                )}
                {createAnalyseStatus === STATUS.SUCESS && (
                    <>
                        <Table className={classes.tableContainer} aria-label="simple table">
                            <TableHead>
                                {headers.map((header) => (
                                    <TableCellHead key={header}>{header}</TableCellHead>
                                ))}
                            </TableHead>
                            <TableBody>
                                {analyseData?.stage_wise_unallocation && analyseData.stage_wise_unallocation.length > 0 ? (
                                    <>
                                        {analyseData.stage_wise_unallocation.map((stage: any, index: number) => (
                                            <TableRowItem
                                                key={index}
                                                row={stage}
                                                tab={tableSwitch}
                                            />
                                        ))}
                                        <TableRow
                                            sx={{
                                                backgroundColor: '#f5f5f5',
                                                fontWeight: 'bold',
                                            }}
                                        >
                                            <TableCellBody>CUMULATIVE TASKS -</TableCellBody>
                                            <TableCellBody>
                                                {analyseData.cumulative_unallocation || 0}
                                            </TableCellBody>
                                        </TableRow>
                                    </>
                                ) : (
                                    <TableRow>
                                        <TableCell colSpan={6} className={classes.noUsersMessage}>
                                            <Error message={'There are no users added as of yet. You can add a user to see it here.'} />
                                        </TableCell>
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>

                    </>
                )}
            </TableContainer>
        </>
    );
};

export default DataInformationUnallocationTable;
